import { useState } from "react";
import { fyaiFaqs } from "@/mocks/fyai-data";

export default function FyaiFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.4fr] lg:gap-16">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            关于风月AI
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            你想了解的下载、系统支持与隐私问题，这里都有答案。还有疑问？欢迎通过页尾邮箱联系风月AI团队。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {fyaiFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`rounded-card border transition-colors ${
                  isOpen ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{faq.q}</span>
                  <i
                    className={`flex-none text-xl text-primary-600 transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}